import { render, staticRenderFns } from "./RepairWorkOrderList.vue?vue&type=template&id=22dd9f46&"
import script from "./RepairWorkOrderList.vue?vue&type=script&lang=js&"
export * from "./RepairWorkOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports